function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".ham_svg__st0{fill:#444242}");

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "ham_svg__st0",
  d: "M1.6 3.2h21.3v1.4H1.6zM1.6 9.5h21.3v1.4H1.6zM1.6 15.8h21.3v1.4H1.6z"
});

function SvgHam(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "ham_svg__Capa_1",
    x: 0,
    y: 0,
    viewBox: "0 0 25 20",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0idXRmLTgiPz4NCjwhLS0gR2VuZXJhdG9yOiBBZG9iZSBJbGx1c3RyYXRvciAyMy4xLjAsIFNWRyBFeHBvcnQgUGx1Zy1JbiAuIFNWRyBWZXJzaW9uOiA2LjAwIEJ1aWxkIDApICAtLT4NCjxzdmcgdmVyc2lvbj0iMS4xIiBpZD0iQ2FwYV8xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB4PSIwcHgiIHk9IjBweCINCgkgdmlld0JveD0iMCAwIDI1IDIwIiBzdHlsZT0iZW5hYmxlLWJhY2tncm91bmQ6bmV3IDAgMCAyNSAyMDsiIHhtbDpzcGFjZT0icHJlc2VydmUiPg0KPHN0eWxlIHR5cGU9InRleHQvY3NzIj4NCgkuc3Qwe2ZpbGw6IzQ0NDI0Mjt9DQo8L3N0eWxlPg0KPHJlY3QgeD0iMS42IiB5PSIzLjIiIGNsYXNzPSJzdDAiIHdpZHRoPSIyMS4zIiBoZWlnaHQ9IjEuNCIvPg0KPHJlY3QgeD0iMS42IiB5PSI5LjUiIGNsYXNzPSJzdDAiIHdpZHRoPSIyMS4zIiBoZWlnaHQ9IjEuNCIvPg0KPHJlY3QgeD0iMS42IiB5PSIxNS44IiBjbGFzcz0ic3QwIiB3aWR0aD0iMjEuMyIgaGVpZ2h0PSIxLjQiLz4NCjwvc3ZnPg0K";
export { SvgHam as ReactComponent };